import React from 'react'
import { CardText, Col, Row } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'

const UserMasterTab3 = ({

    floatValue,
    floatonChange,

    CsignOnValue,
    CsignonOnChange,
    CsignoffValue,
    CsignoffOnChange,
    CtempsignValue,
    CtempsignonChange,
    manageSignValue,
    manageSignOnChange,
    floatOnChange,
    crEnable,
    signlocation,
    terminalID,
    signOnDate,
    signOnTime,
    shift,
    signOffDate,
    signOffTime
}) => {

    return (
        <React.Fragment>
            <div>
                <Row>
                    <Col sm="12">
                        <CardText className="mb-4-sm">
                            <Row>
                                {crEnable ? <Col sm={12} md={6} className="mb-4-sm">
                                    <DPTextBox
                                        rowClass="mb--sm"
                                        labelText="Last Float"
                                        textType="text"
                                        textAlign="right"
                                        value={floatValue}
                                        onChange={floatonChange}
                                        onBlur={floatOnChange}
                                        disabled={true}
                                    />
                                    <Row className='mt-1'>
                                        <Col sm={3}>Cashier sign on</Col>
                                        <Col >
                                            <DPSwitch
                                                rowClass={"mb-4-sm"}
                                                onChange={CsignonOnChange}
                                                checked={CsignOnValue}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className='mt-1'>
                                        <Col sm={3}>Cashier sign off</Col>
                                        <Col >
                                            <DPSwitch
                                                rowClass={"mb-4-sm"}
                                                onChange={CsignoffOnChange}
                                                checked={CsignoffValue}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className='mt-1'>
                                        <Col sm={3}>Temporarry sign on</Col>
                                        <Col >
                                            <DPSwitch
                                                rowClass={"mb-4-sm"}
                                                onChange={CtempsignonChange}
                                                checked={CtempsignValue}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className='mt-1'>
                                        <Col sm={3}>Manager sign off Completed</Col>
                                        <Col >
                                            <DPSwitch
                                                rowClass={"mb-4-sm"}
                                                onChange={manageSignOnChange}
                                                checked={manageSignValue}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                </Col> : null}
                                {crEnable ? <Col sm={12} md={6} className="mb-4-sm">
                                    <Row>
                                        <Col>signed on location</Col>
                                        <Col>{signlocation}</Col>
                                    </Row>
                                    <p></p>
                                    <Row>
                                        <Col>logged POS terminal ID</Col>
                                        <Col>{terminalID}</Col>
                                    </Row>
                                    <p></p>
                                    <Row>
                                        <Col>Last sign on date</Col>
                                        <Col>{signOnDate.slice(0, 10)}</Col>
                                    </Row>
                                    <p></p>
                                    <Row>
                                        <Col>Last sign on time</Col>
                                        <Col>{signOnTime.slice(11, 19)}</Col>
                                    </Row>
                                    <p></p>
                                    <Row>
                                        <Col>Current shift number</Col>
                                        <Col>{shift}</Col>
                                    </Row>
                                    <p></p>
                                    <Row>
                                        <Col>Last sign off date</Col>
                                        <Col>{signOffDate.slice(0, 10)}</Col>
                                    </Row>
                                    <p></p>
                                    <Row>
                                        <Col>Last sign off time</Col>
                                        <Col>{signOffTime.slice(11, 19)}</Col>
                                    </Row>
                                </Col> : null}
                            </Row>
                        </CardText>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )

}

export default UserMasterTab3